import theme from "css/themes/homePage/careers.css";
import React, { Component } from "react";
import CurrentOpenings from "visual-components/careers/shared/current-openings";
import OurValues from "visual-components/careers/shared/our-values";
import PerksAndBenefits from "visual-components/careers/shared/perks-and-benefits";
import Footer from "../footer/Footer";
import CareersBanner from "./careers-banner";

class Careers extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className={theme.careersPage}>
        <CareersBanner />
        <PerksAndBenefits />
        <OurValues />
        <CurrentOpenings />
        <Footer />
      </div>
    );
  }
}

export default Careers;
